import * as React from 'react';
import { FocusEventHandler, ReactNode } from 'react';

import { AutocompleteRenderInputParams } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';

import Input from '../../components/ui/Input';
import { styleDropdown } from '../style-dropdown/style-dropdown.util';

export const getRenderInput = <TFormikValuesModel,>(
  label: string,
  name: keyof TFormikValuesModel,
  errors: FormikErrors<TFormikValuesModel>,
  touched: FormikTouched<TFormikValuesModel>,
  required: boolean = false,
  withStyles: boolean = false,
  handleBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
): ((params: AutocompleteRenderInputParams) => ReactNode) =>
  function (params: AutocompleteRenderInputParams): ReactNode {
    const parameters = withStyles ? styleDropdown(params) : params;
    return (
      <Input
        {...parameters}
        key={parameters.id}
        label={label}
        name={name as string}
        onBlur={handleBlur}
        variant="filled"
        {...(required && {
          InputLabelProps: {
            required,
          },
        })}
        helperText={!!errors[name] && touched[name] && errors[name]}
        error={touched[name] && !!errors[name]}
      />
    );
  };
